import { ButtonProps } from 'components/Button';
import { ElementType } from 'react';
import { EmployerInterviewEventTypeResource } from 'util/resources/EmployerInterviewEventType';
import { EmployerInterviewSlotResource } from 'util/resources/EmployerInterviewSlot';
import { UserProfileMetadataResource } from 'util/resources/UserProfileMetadata';

export enum ButtonState {
  DEFAULT = 'DEFAULT',
  INVITATION_SENT = 'INVITATION_SENT',
  INTERVIEW_CANCELED = 'INTEVIEW_CANCELED',
  INTERVIEW_SCHEDULED = 'INTEVIEW_SCHEDULED',
  INTERVIEW_ATTENDED = 'INTEVIEW_ATTENDED',
}

export type ButtonStateProps = {
  button: {
    variant: ButtonProps['variant'];
    btnClassName?: string;
    icon: ElementType;
    label: string;
  };
  message?: {
    messageClassName?: string;
    icon?: ElementType;
    prefix?: string;
    preventInvite?: boolean;
  };
};

export type EmployerInterviewButtonProps = {
  /**
   * Class of root element
   * @required
   */
  className?: string;

  /**
   * Educator Id
   * @required
   */
  educatorId: string;

  /**
   * User Profile Metadata resource
   * @default undefined
   */
  userProfileMetaData?: UserProfileMetadataResource;

  /**
   * Whether the button should be disabled
   * @default undefined
   */
  disabled?: boolean;

  /**
   * Callback fired when interview message has been sent
   * @default undefined
   */
  onInviteSend?: () => void;

  /**
   * PostHog properties
   * @default {}
   */
  posthog?: {
    eventName: string;
    properties?: {
      [prop: string]: any;
    };
  };

  /**
   * If `true`, it'll only show the button, not the label under it
   * @default false
   */
  onlyButton?: boolean;

  /**
   * List of EmployerInterviewEventType resource
   * @required
   */
  interviewEventTypes: EmployerInterviewEventTypeResource[];

  /**
   * List of EmployerInterviewSlot respoirce
   * @required
   */
  availabilitySlots: EmployerInterviewSlotResource[];
};
